import { AccountReportUsageAndAccessEntity } from '../entities/';
import { authResource } from './Auth';
import { schema } from '@data-client/rest';
export const AccountReportUsageAndAccessResource = authResource({
    path: '/accounts/:accountId/reports/usageandaccess/:useageAndAccessId?',
    searchParams: {},
    schema: AccountReportUsageAndAccessEntity
}).extend('getList', {
    schema: {
        counts: new schema.Collection([AccountReportUsageAndAccessEntity]),
        items: new schema.Collection([AccountReportUsageAndAccessEntity])
    }
});
